// extracted by mini-css-extract-plugin
module.exports = {"root":"popover-content-footer_root__oeYTB"};